define('viewModels/privileged/qm/policies/editors/SurveyFormSelectorView',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',
    'moment',
    'services/composer/surveyFormService',
    'viewModels/ViewModel'
], function (_,
    Promise,
    ko,
    moment,
    surveyFormService,
    ViewModel) {
    'use strict';

    /**
     * The SurveyFormSelectorView class.
     * @class
     */
    var SurveyFormSelectorView = ViewModel.extend(function (surveyFormObservable) {
        var self = this;

        self.loading = ko.observable(false);
        self.surveyForm = surveyFormObservable;
        self.placeholderText = ko.i18n.renderString('surveyFormSelector.placeholderText');

        self.getPublishedSurveyForms = function (searchTerm) {
            return surveyFormService.get.published.page({ name: searchTerm, onlyLatestEnabledPerContext: true }).then(function (surveyFormsPage) {
                // Make sure survey forms from surveyFormService get unwrapped.
                // They are initialized with utility functions for editing and validating
                // (that we don't care about) which cause the model to be rejected
                // by the service otherwise.
                var surveyForms = _.invokeMap(surveyFormsPage.asList(), 'unwrap');
                return surveyForms;
            });
        };

        if (_.isArray(self.surveyForm())) {
            self.surveyForm.extend({ deepComparer: true, minLength: { params: 1, message: "surveyFormSelector.noFormSelected" } });
        } else {
            self.surveyForm.extend({ required: true });
        }

    }, true /* pass args to extended class */);

    return SurveyFormSelectorView;
});

